import React from 'react';

const LoadingScreen: React.FC = () => {
  return (
    <div className="fixed inset-0 z-[100] bg-slate-50 dark:bg-[#050505] flex flex-col items-center justify-center font-mono transition-colors duration-300">
      <div className="flex flex-col items-center gap-4">
        <div className="relative w-16 h-16">
          <div className="absolute inset-0 border-4 border-slate-200 dark:border-white/10 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-emerald-600 dark:border-[#39ff14] rounded-full border-t-transparent animate-spin"></div>
        </div>
        <div className="text-sm font-bold tracking-widest text-slate-900 dark:text-white flex items-center gap-2">
          <span className="text-emerald-600 dark:text-[#39ff14]">{'>'}</span>
          INITIALIZING_CORE...
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;